import Home from './components/Home';
import data from './data.json';

function App() {
  return <Home data={data} />;
}

export default App;
